// extracted by mini-css-extract-plugin
module.exports = {"section7":"Section7_section7__MLm2c","container":"Section7_container__j4_W1","button":"Section7_button__vm_b_"};